import { createContext, useContext } from 'react';
import { store, IGlobalStore, ICommonStore } from '@store/index';

export const StoreContext = createContext(store);

const useStore = (): Omit<IGlobalStore, keyof ICommonStore> => useContext(StoreContext);

export default useStore;
